export default __webpack_public_path__ + "f7be14510de67e78bc106e50b1ee884d.png";